import { formatDateTypeEnum } from "../../enums/general/formatDateTypeEnum";

const formateTimeStamp = (timestamp, formatDateType) => {
  const date = new Date(timestamp);

  // Extracting the individual parts of the date and time
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  switch (formatDateType) {
    case formatDateTypeEnum.date:
      return `${day}/${month}/${year}`;
    case formatDateTypeEnum.time:
      return `${hours}:${minutes}:${seconds}`;
    default:
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }
};

const getTimeDuration = (startTime, endTime) => {
  const duration = endTime.getTime() - startTime.getTime();

  return convertMiliSeconedToHourAndMinute(duration);
};

const convertMiliSeconedToHourAndMinute = (time) => {
  let seconds = Math.floor(time / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);

  seconds = seconds % 60;
  minutes = minutes % 60;
  hours = hours % 24;

  return `${formateTime(hours)}:${formateTime(minutes)}:${formateTime(seconds)}`;
};

const formateTime = (time) => {
  return time.toString().padStart(2, "0");
};

const datesHelper = {
  formateTimeStamp,
  getTimeDuration,
  convertMiliSeconedToHourAndMinute,
  formateTime,
};

export default datesHelper;
